import { Link } from "react-router-dom";
import { Download, MousePointerClick, UserPlus, Lock, ScrollText, Server } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { FAQ, IMG } from "./data";
import { Section } from "./ui";

const STEPS = [
  { icon: UserPlus, title: "Créez votre espace", text: "Inscription en 30 secondes, 14 jours d'essai gratuit." },
  { icon: Download, title: "Installez l'agent", text: "Un assistant Suivant / Installer / Terminer sur chaque poste, rangé automatiquement dans le bon client." },
  { icon: MousePointerClick, title: "Prenez la main", text: "Le poste apparaît en ligne : cliquez sur « Participer »." },
];

export const Steps = () => (
  <Section id="demarrer" over="DÉMARRER" title="Opérationnel en 5 minutes">
    <ol className="grid md:grid-cols-3 gap-6 mb-12">
      {STEPS.map((s, i) => (
        <li key={s.title} className="rounded-2xl border border-slate-800 p-6">
          <span className="font-mono text-xs text-sky-400">ÉTAPE {i + 1}</span>
          <s.icon className="h-6 w-6 text-sky-400 my-3" />
          <p className="font-bold mb-1">{s.title}</p>
          <p className="text-sm text-slate-400">{s.text}</p>
        </li>
      ))}
    </ol>
    <Button asChild size="lg" className="rounded-full px-8"><Link to="/register" data-testid="cta-register-btn">Créer mon espace gratuitement</Link></Button>
  </Section>
);

const SEC = [
  [Lock, "Connexions chiffrées et double authentification pour chaque technicien"],
  [ScrollText, "Journal d'audit : qui s'est connecté, où, quand et ce qui a été fait"],
  [Server, "L'utilisateur voit quand un technicien est connecté et peut demander de l'aide"],
];

export const Security = () => (
  <section className="relative border-t border-slate-800/70 overflow-hidden" id="securite">
    <img src={IMG.servers} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#090D16] via-[#090D16]/90 to-[#090D16]/60" />
    <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-28">
      <p className="font-mono text-xs tracking-[0.2em] text-sky-400 mb-3">SÉCURITÉ</p>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight max-w-2xl mb-10">Vos clients vous confient leurs postes. Nous prenons ça au sérieux.</h2>
      <ul className="grid md:grid-cols-3 gap-6 max-w-5xl">
        {SEC.map(([I, t]) => <li key={t} className="rounded-xl border border-slate-700/70 bg-slate-900/70 backdrop-blur p-5 text-slate-300"><I className="h-5 w-5 text-sky-400 mb-3" />{t}</li>)}
      </ul>
    </div>
  </section>
);

export const Faq = () => (
  <Section id="faq" over="QUESTIONS FRÉQUENTES" title="Vous vous posez sûrement ces questions">
    <Accordion type="single" collapsible className="max-w-3xl">
      {FAQ.map(([q, a], i) => (
        <AccordionItem key={q} value={`q${i}`} className="border-slate-800">
          <AccordionTrigger className="text-left hover:no-underline hover:text-sky-300" data-testid={`faq-q-${i}`}>{q}</AccordionTrigger>
          <AccordionContent className="text-slate-400 leading-relaxed">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </Section>
);
